/**
 * Created by andrey on 08.08.2025
 */

cc.bezierAt = function (a, b, c, d, t) {
    return (Math.pow(1 - t, 3) * a
        + 3 * t * (Math.pow(1 - t, 2)) * b
        + 3 * Math.pow(t, 2) * (1 - t) * c
        + Math.pow(t, 3) * d);
};

cc.BezierBy = function (duration, config) {
    cc.ActionInterval.prototype.constructor.call(this);
    this._config = [];
    this._startPosition = cc.p(0, 0);
    this._previousPosition = cc.p(0, 0);

    if (config !== undefined) {
        this.initWithDuration(duration, config);
    }
};

cc.BezierBy.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.BezierBy,

    initWithDuration: function (t, c) {
        if (cc.ActionInterval.prototype.initWithDuration.call(this, t)) {
            this._config = c;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        const locPosX = target.getPositionX();
        const locPosY = target.getPositionY();
        this._previousPosition.x = locPosX;
        this._previousPosition.y = locPosY;
        this._startPosition.x = locPosX;
        this._startPosition.y = locPosY;
    },

    update: function (dt) {
        dt = this._computeEaseTime(dt);
        if (this.target) {
            const locConfig = this._config;
            const xa = 0;
            const xb = locConfig[0].x;
            const xc = locConfig[1].x;
            const xd = locConfig[2].x;

            const ya = 0;
            const yb = locConfig[0].y;
            const yc = locConfig[1].y;
            const yd = locConfig[2].y;

            let x = cc.bezierAt(xa, xb, xc, xd, dt);
            let y = cc.bezierAt(ya, yb, yc, yd, dt);

            const locStartPosition = this._startPosition;
            if (cc.ENABLE_STACKABLE_ACTIONS) {
                const targetX = this.target.getPositionX();
                const targetY = this.target.getPositionY();
                const locPreviousPosition = this._previousPosition;

                locStartPosition.x = locStartPosition.x + targetX - locPreviousPosition.x;
                locStartPosition.y = locStartPosition.y + targetY - locPreviousPosition.y;
                x += locStartPosition.x;
                y += locStartPosition.y;
                locPreviousPosition.x = x;
                locPreviousPosition.y = y;
                this.target.setPosition(x, y);
            } else {
                this.target.setPosition(locStartPosition.x + x, locStartPosition.y + y);
            }
        }
    }
});

cc.bezierBy = (duration, config) => new cc.BezierBy(duration, config);